function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { rem } from 'polished';
import React from 'react';
import Box from '../Box';
const ColumnsIcon = _ref => {
  let {
    size = 16,
    bg = 'currentColor',
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, _extends({
    as: "svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 26",
    width: rem(size),
    height: rem(size),
    fill: bg,
    verticalAlign: "middle"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 23H12V5H2v17.5c0 .3.2.5.5.5zm21.5-.5V5H14v18h9.5c.3 0 .5-.2.5-.5zm2-19v19c0 1.4-1.1 2.5-2.5 2.5h-21C1.1 25 0 23.9 0 22.5v-19C0 2.1 1.1 1 2.5 1h21C24.9 1 26 2.1 26 3.5z"
  }));
};
export default ColumnsIcon;